import styled from 'styled-components';
import {memo, ReactNode} from 'react';
import {ifProp} from 'styled-tools';
import {getColorFromTheme} from '../../ui-utils';
import {TChildProps} from '../../interface';

const Wrapper = styled.section<{errors?: boolean; $createGoal?: boolean}>`
  background: ${({$createGoal, theme}) =>
    $createGoal ? theme.colors.white : 'transparent'};
  border: 1px solid;
  border-color: ${ifProp(
    'errors',
    getColorFromTheme('red400'),
    getColorFromTheme('borderLight'),
  )};
  border-radius: 10px;
`;

const FooterWrapper = styled.div<{
  errors?: boolean;
  $createGoal?: boolean;
}>`
  border-top: 1px solid;

  border-color: ${ifProp(
    'errors',
    getColorFromTheme('red400'),
    getColorFromTheme('borderLight'),
  )};
  border-radius: 0px 0px 10px 10px;
  padding: ${({$createGoal}) =>
    $createGoal ? '16px 16px 16px 34px' : '16px 12px'};
`;

const Container = styled.div<{$createGoal?: boolean}>`
  padding: ${({$createGoal}) =>
    $createGoal ? '24px 16px 16px' : '24px 12px 16px'};
`;

export interface TActionCardProps extends TChildProps {
  footer: ReactNode;
  errors?: boolean;
  createGoal?: boolean;
}

export const ActionCard = memo(function ({
  footer,
  children,
  errors,
  createGoal,
}: TActionCardProps) {
  return (
    <Wrapper errors={errors} $createGoal={createGoal}>
      <Container $createGoal={createGoal}>{children}</Container>
      <FooterWrapper errors={errors} $createGoal={createGoal}>
        {footer}
      </FooterWrapper>
    </Wrapper>
  );
});

ActionCard.displayName = 'ActionCard';
